"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFloorLevel = void 0;
const site_1 = require("@yanzi/site");
const react_1 = require("react");
const useRouterState_1 = require("./useRouterState");
function useFloorLevel() {
    const { data: defaultFloor } = site_1.useDefaultFloor();
    const [floorLevel, setFloorLevel] = useRouterState_1.useRouterState('floorLevel', defaultFloor);
    react_1.useEffect(() => {
        if (floorLevel == null && defaultFloor !== null) {
            setFloorLevel(defaultFloor);
        }
    }, [defaultFloor, setFloorLevel, floorLevel]);
    return react_1.useMemo(() => [floorLevel, setFloorLevel], [
        floorLevel,
        setFloorLevel,
    ]);
}
exports.useFloorLevel = useFloorLevel;
//# sourceMappingURL=useFloorLevel.js.map